<template>
  <template v-if="shouldRender">
    <button class="venue-info-widget" aria-label="View venue info" @click="handleWidgetInfoClick">
      <i class="venue-info-widget__icon icon icon-Info" aria-hidden="true"></i>
    </button>
    <venue-info-modal ref="modalRef" v-bind="props" />
  </template>
</template>

<script setup lang="ts">
import { ref, defineAsyncComponent, watch, useTemplateRef } from 'vue';
import { useVenueInfoQuery } from '../../../utils/queries/useVenueInfoQuery';
import type { VenueInfoWidgetProps } from './types';

const VenueInfoModal = defineAsyncComponent(
  () => import(/* webpackChunkName: "VenueInfoModal" */ '../../VenueInfoModal/VenueInfoModal.vue')
);

const emit = defineEmits<{
  widgetInfoClick: [];
}>();

const props = withDefaults(defineProps<VenueInfoWidgetProps>(), {
  dates: () => ({}),
  headingType: 'h3',
  showVenueInfoFirst: true,
});

const { data } = useVenueInfoQuery(props.venueId);

const modalRef = useTemplateRef('modalRef');
const shouldRender = ref(false);

const handleWidgetInfoClick = () => {
  if (!modalRef.value) return;
  emit('widgetInfoClick');
  modalRef.value.openModal();
};

watch(
  data,
  () => {
    if (data?.value?.hasAnyVenueData) shouldRender.value = true;
  },
  { immediate: true }
);
</script>

<style lang="scss">
@import './scss/VenueInfoWidget.scss';
</style>
